import { connect } from "react-redux"

import {
  getIsLoading,
  getHasResults,
  getAll
} from "../store/businessLibrary.selectors"
import { loadAll } from "../store/businessLibrary.actions"

import List from "../components/PostList"

const AllPosts = postType => {
  const mapState = state => ({
    isLoading: getIsLoading(state),
    posts: getAll(state),
    noResults: !getHasResults(state),
    type: postType
  })

  const mapDispatch = dispatch => ({
    onLoad: () => dispatch(loadAll({ postType }))
  })

  return connect(mapState, mapDispatch)(List)
}

export default AllPosts
